// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"38fa9bb5","501":"13f1a6d6","510":"d963b1db","548":"83aa5ab7","551":"632e15de","651":"ce98edb1","741":"a76bc753"}[chunkId] + ".chunk.js";
};